import { render, staticRenderFns } from "./ComposeNoteEditor.vue?vue&type=template&id=07a932e7&scoped=true"
import script from "./ComposeNoteEditor.vue?vue&type=script&lang=js"
export * from "./ComposeNoteEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a932e7",
  null
  
)

export default component.exports